import { FC } from 'react';
import { useRouter } from 'next/router';
import TeaserUS from './teaser_us';
import TeaserEU from './teaser_eu';
import TeaserJP from './teaser_jp';
import CrowdFunding from './crowdfunding';
import DetailUS from './detail_us';
import { Delta2MaxProps, STAGES } from '@/constants/delta2max';
import EfScrollAni from '@/efscrollani';

const Delta2MaxH5: FC<Delta2MaxProps> = ({ stage, productDetail, resProductCatagory, supportData, crowdfundingTimeline, nowSysTime }: Delta2MaxProps) => {
    const { locale = 'us' } = useRouter();

    const props: any = {
        productDetail,
        resProductCatagory,
        crowdfundingTimeline,
        supportData,
        nowSysTime,
    };

    // 欧洲站点
    const EU_SITE = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'au', 'ph', 'nl'];
    // 北美站点
    const NA_SITE = ['us', 'ca', 'br', 'mx'];
    // 日本 中国？
    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }

    return (
        <div className="delta-2-max">
            {stage === STAGES.TEASER && [...NA_SITE, 'za'].includes(locale) && <TeaserUS />}
            {stage === STAGES.TEASER && EU_SITE.includes(locale) && <TeaserEU locale={locale} />}
            {stage === STAGES.TEASER && ['jp'].includes(locale) && <TeaserJP />}
            {stage === STAGES.CROWDFUNDING && <CrowdFunding {...props} />}
            {stage === STAGES.DETAIL && [...EU_SITE, 'jp', 'cn', 'za', 'sa'].includes(locale) && <TeaserEU stage={STAGES.DETAIL} locale={locale} />}
            {stage === STAGES.DETAIL && [...NA_SITE, 'tw'].includes(locale) && <DetailUS />}
        </div>
    );
};

export default Delta2MaxH5;
